<template>
  <div class="con" v-loading="loading">
    <div class="text item">
      <!-- <network-info :network-info="networkInfo"></network-info> -->
      <!-- <div class="setting">功能配置</div> -->
      <div class="Table-Con">
        <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
          <el-form-item :label="`${$t('lang.ConfigSetting.Hostname')}:`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.hostname"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Timezone')}:`" prop="name">
            <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.zonename" size="mini"
              class="Form-Input-Width">
              <el-option v-for="item in AsiaList" :key="item.zonename" :label="item.zonename" :value="item.zonename">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Language')}:`" prop="name">
            <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.lang" size="mini"
              class="Form-Input-Width">
              <el-option v-for="item in LanguageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.WANMode')}:`" prop="name">
            <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.wan_mode" size="mini"
              class="Form-Input-Width">
              <el-option v-for="item in WanList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.trandform')}:`" prop="name"
            v-if="data.wan_mode == 'wireless'">
            <el-checkbox v-model="data.ifname"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.NTPclient')}:`" prop="region">
            <el-checkbox v-model="data.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.NTPserver')}:`" prop="region" v-if="data.enabled">
            <el-checkbox v-model="data.enable_server"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.servercandidates')}:`" prop="region" v-if="data.enabled">
            <arr-add-inpit @GetArrList="GetArrList" :List="data.server"></arr-add-inpit>
          </el-form-item>
          <!-- 模组调试 -->
          <!-- <el-form-item :label="`${$t('lang.ConfigSetting.WANtoLAN')}:`" prop="region">
            <el-checkbox v-model="data.wan_to_lan"></el-checkbox>

          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
      {{ $t('lang.ConfigSetting.SaveApply') }}
    </el-button>
  </div>
</template>
<script>
import ArrAddInpit from '../ArrAddInput/index'
import { updateConfig, listConfig, getNetworkInfo } from '@/api/configurationlist'
import { progressControl } from "@/api/particulars";
import { zone } from '../zone'
import { cloneDeep, isEqual } from 'lodash'
// import networkInfo from '../networkInfo/index'

export default {
  props: ["deviceDid", "deviceSn", "deviceSoftwareVer"],
  data() {
    return {
      AsiaList: zone,
      AsiaValue: '',
      LanguageList: [
        { value: 'zh_cn', label: '简体中文(Chinese)' },
        { value: 'en', label: 'English' },
        { value: 'zh_tw', label: '繁体中文(Chinese)' }
      ],
      LanguageValue: '',
      WanList: [
        { value: 'wireless', label: this.deviceSoftwareVer < "v2.7" ? this.$t('lang.ConfigSetting.G3G4') : this.$t('lang.ConfigSetting.G4G5') },
        { value: 'all', label: this.$t('lang.ConfigSetting.andWired') },
        { value: 'wired', label: this.$t('lang.ConfigSetting.Wired') }
      ],
      WanValue: '',
      checked: true,
      //上传配置
      WatchData: {
        hostname: '',
        wan_mode: '',
        zonename: '',
        server: '',
        enable_server: '',
        enabled: false,
        lang: ''
      },
      data: {},
      ifname: '',
      ifnameOptions: [],
      // ifnameOptions: ['eth0 eth1', 'eth0.1 eth1'],
      loading: true,
      error: {
        hostname: false
      },
      UpData: true,
      // 网络接口基本信息
      networkInfo: {},
      wan_name: ''
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig()
      },
    }
  },
  methods: {
    //获取配置参数 
    getConfig() {
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "system",
          config: "system",
          options: [
            { option: "ttylogin" },
            { option: "hostname" },
            { option: "zonename" },
            { option: "wan_to_lan" }
          ]
        },
        {
          section: "ntp",
          config: "system",
          options: [{ option: "enabled" }, { option: "enable_server" }],
          lists: [{ list: "server" }]
        },
        { section: "main", config: "luci", options: [{ option: "lang" }] },
        (this.deviceSoftwareVer < "v2.7" ? {
          section: "initconfig",
          config: "system",
          options: [{ option: "wan_mode" }]
        } : {
          section: "system",
          config: "ciot",
          options: [{ option: "wan_mode" }]
        }),
        {
          section: "lan",
          config: "network",
          options: [{ option: "ifname" }]
        },
        {
          section: "wan",
          config: "network",
          options: [{ option: "ifname" }]
        }
      ]).then(res => {
        const data = res.data.data.mess;
        console.log(data);

        //筛选参数
        this.$set(
          this.data,
          "hostname",
          data[0].s_objects[0].options.hostname
        );
        this.$set(
          this.data,
          "zonename",
          data[0].s_objects[0].options.zonename
        );
        this.$set(
          this.data,
          "wan_to_lan",
          data[0].s_objects[0].options.wan_to_lan
        );
        this.$set(
          this.data,
          "server",
          data[1].s_objects[0].lists.server
        );
        this.$set(
          this.data,
          "enable_server",
          data[1].s_objects[0].options.enable_server
        );
        this.$set(
          this.data,
          "s_objects",
          data[1].s_objects[0].options.s_objects
        );
        this.$set(
          this.data,
          "enabled",
          data[1].s_objects[0].options.enabled
        );
        this.wan_name = data[5].s_objects[0].options.ifname
        this.ifnameOptions = data[4].s_objects[0].options.ifname.split(" ")
        this.$set(
          this.data,
          "lang",
          data[2].s_objects[0].options.lang
        );
        this.$set(
          this.data,
          "wan_mode",
          data[3].s_objects[0].options.wan_mode
        );
        this.ifname = cloneDeep(data[5].s_objects[0].options.ifname);
        this.$set(
          this.data,
          "ifname",
          // this.ifnameOptions.includes(this.ifname) ? true : false
          data[4].s_objects[0].options.ifname.indexOf(data[5].s_objects[0].options.ifname) != -1
        );
        this.data.enabled = this.data.enabled === '1' 
        this.data.enable_server = this.data.enable_server === '1' 
        this.data.wan_to_lan = this.data.wan_to_lan == '1' ? true : false
        this.WatchData = cloneDeep(this.data)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    GetArrList(Arr) {
      this.data.server = Arr
    },
    //修改配置
    updateConfig() {
      if (this.error.hostname) {
        return
      }
      if (!isEqual(this.data, this.WatchData)) {
        let data = {}
        //循环筛选不为空的值，(不为空则未修改无需上传)
        for (let key in this.data) {
          if (this.data[key] !== '') {
            data[key] = this.data[key]
          }
        }
        let submitArry = [
          {
            section: "system",
            config: "system",
            server: 'system',
            action: 0,
            index: [0],
            options: {
              hostname: this.data.hostname,
              zonename: this.data.zonename
            },
          },
          {
            section: "ntp",
            config: "system",
            action: 0,
            index: [0],
            lists: { server: this.data.server },
            options: {
              enable_server: this.data.enable_server ? '1' : '0',
              enabled: this.data.enabled ? '1' : '0'
            }
          },
          {
            section: "main",
            config: "luci",
            action: 0,
            index: [0],
            options: {
              lang: this.data.lang
            }
          },
          (this.deviceSoftwareVer < "v2.7" ? {
            section: "initconfig",
            config: "system",
            action: 0,
            index: [0],
            server: 'system',
            options: {
              wan_mode: this.data.wan_mode
            }
          } : {
            section: "system",
            config: "ciot",
            action: 0,
            index: [0],
            options: {
              wan_mode: this.data.wan_mode
            },
          }),
          {
            section: "lan",
            config: "network",
            action: 0,
            index: [0],
            options: {
              ifname: this.ifnameOptions.join(' ')
            }
          }
        ]
        //3G/4G模式时,开启wan->lan在原有的ifname基础上加上eth1
        if (this.data.wan_mode == 'wireless') {
          // 原来没有开启wan->lan，现在开启
          // if (Object.keys(data).length > 0) {
          //   let item = {}
          //   if (!this.ifnameOptions.includes(this.ifname) && this.data.ifname) {
          //     submitArry[4].options.ifname = this.ifname.split(' ')[0] + ' ' + this.wan_name
          //   } else if (!this.ifnameOptions.includes(this.ifname) && !this.data.ifname) { // 原来不开启，现在也不开启
          //     submitArry[4].options.ifname = this.ifname.split(' ')[0]
          //   } else if (this.ifnameOptions.includes(this.ifname) && !this.data.ifname) { // 原来开启，现在不开启
          //     submitArry[4].options.ifname = this.ifname.split(' ')[0]
          //   } else if (this.ifnameOptions.includes(this.ifname) && !this.data.ifname) { // 原来开启，现在也开启
          //     submitArry[4].options.ifname = this.ifname.split(' ')[0]
          //   }
          // }
          if (this.data.ifname) {
            if (!this.ifnameOptions.includes(this.ifname)) {
              let ifname = this.ifnameOptions;
              ifname.push(this.ifname)
              ifname = ifname.join(' ')
              submitArry[4].options.ifname = ifname
            }
          } else {
            if (this.ifnameOptions.includes(this.ifname)) {
              // 排除this.ifanme
              submitArry[4].options.ifname = this.ifnameOptions.filter(item => item != this.ifname).join(' ')
            }
          }
        } else {
          // submitArry[4].options.ifname = this.ifname.split(' ')[0]
        }
        updateConfig(this.deviceSn, this.deviceDid, submitArry).then((res) => {
          this.UpData = true
          //wan转lan转换
          // this.data.ifname=this.data.ifname=='eth0 eth1'?true:false
          if (res.data.data.mess === 0) {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            })
            let ntp = [];
            if (this.data.enabled != this.WatchData.enabled) {
              if (this.data.enabled)
                ntp.push({
                  process: 'sysntpd',
                  type: 0,
                  action: 'start'
                })
              else
                ntp.push({
                  process: 'sysntpd',
                  type: 0,
                  action: 'stop'
                })
            }
            // 重启network配置
            progressControl([
              {
                process: 'network',
                type: 0,
                action: 'reload'
              },
              ...ntp
            ], this.deviceDid.toString(), this.deviceSn).then(res => {
              this.getConfig()
            }).catch(() => {
            })

          } else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
            return
          }
        })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      }

    },
  },
  components: {
    ArrAddInpit,
    // networkInfo
  },
}
</script>
<style src='../common.css' scoped></style>
